import { AppAuthService } from 'src/app/services/auth/app-auth.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { RouterService } from 'src/app/services/router/router.service';
import { MaintenanceMenuService } from 'src/app/shared/maintenance-menu/maintenance-menu.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-set-reference-controls',
  templateUrl: './set-reference-controls.component.html',
  styleUrls: ['./set-reference-controls.component.scss']
})
export class SetReferenceControlsComponent implements OnInit, AfterViewInit {
  private FileData: FormData;
  public organization: string;

  constructor(
    public maintenanceMenuService: MaintenanceMenuService,
    private routerService: RouterService,
    private appAuthService: AppAuthService
  ) { }

  ngOnInit(): void {
    this.routerService.setPreviousPage();
    this.organization = environment.organization;
  }

  ngAfterViewInit(): void {
  }

  public getFile(file: FormData) {
    this.FileData = file;
  }

  public uploadFile() {
    // this.FileDataをバックエンドに送信する
  }
}
